import React, { useState, useMemo } from "react";
import { BasicTabs, CardWithActions, LineDivider } from "@/components";
import AttendanceDetails from "@/pages/attendanceManagement/adminAttendanceMuster/AttendanceDetails";
import { BulkOverride } from "@/pages/attendanceManagement";
import { OverrideHistory } from "@/pages/attendanceManagement";
import CardContent from "../components/CardContent";

const AdminAttendanceMuster = () => {
  return (
    <>
      <CardContent title="Admin Attendance Muster">

        <BasicTabs
          tabs={[
            {
              label: "Attendance Details",
              component: <AttendanceDetails />,
            },
            {
              label: "Bulk Override",
              component: <BulkOverride />,
            },
            {
              label: "Override History",
              component: <OverrideHistory />,
            },
          ]}
        />
      </CardContent>
    </>
  );
};

export default AdminAttendanceMuster;
